import WrapperBackgroundBanner from '../../XcalaComponents/WrapperBackgroundBanner';
import WrapperContentApp from '../../XcalaComponents/WrapperContentApp';
import AvatarRescue from './AvatarRescue';

const fileAs = {
  currency: 'pesos',
  fileAs: 'file as',
  fileAsComplete: 'file as complete',
  risk: 'agresivo',
  profit: '10',
};

const HeaderRescuePortfolio = ({ amountPortfolio, portfolioFileAsComplete }) => {
  return (
    <WrapperBackgroundBanner>
      <WrapperContentApp
        fileAs={fileAs}
        direction={{ md: 'row', xs: 'column' }}
        justifyContent='center'
        padding={'40px 0'}>
        <AvatarRescue
          mountPortfolio={amountPortfolio}
          portfolioFileAsComplete={portfolioFileAsComplete}
        />
      </WrapperContentApp>
    </WrapperBackgroundBanner>
  );
};

export default HeaderRescuePortfolio;
